import {withState} from 'shared/core';
import {Button, Display, InlineDatePicker, Layout, Panel, Select2} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {calendarDate} from 'shared/tools/dates';
import {timeZoneOptions} from 'shared/tools/timeZones';
import EventDetails from './EventDetails';
import ScheduleInterviewState from '../../state/ScheduleInterviewState';

const ScheduleInterviewContainer = observer(({uiState}) => {
  const {interviewInvite, selectedDate, selectedSlot, timeZone} = uiState;
  const {logoUrl, companyName, interviewSchedule} = interviewInvite;

  return (
    <div>
      <Panel className='branded-header'>
        <div className='flex justify-center h1 medium py1'>
          {logoUrl ?
            <img alt='company logo' className='align-top CompanyLogo-img' style={{maxHeight: '35px'}} src={logoUrl}/> :
            companyName
          }
        </div>
      </Panel>
      <Display title={interviewSchedule.calendarEventName}/>
      <Layout>
        <Panel>
          <div className='grid lg:grid-cols-12 gap-8 align-items-start'>
            <div className='col-span-4 space-y-4'>
              <EventDetails uiState={uiState} />
            </div>
            <div className='col-span-4'>
              <div className='max-w-md mx-auto space-y-2'>
                <InlineDatePicker
                  key={timeZone}
                  value={selectedDate}
                  onChange={date => uiState.setSelectedDate(date)}
                  options={{
                    maxViewMode: 0,
                    defaultViewDate: uiState.firstAvailableDate,
                    beforeShowDay: date => uiState.isDateBookable(date) && 'interview-slot-available'
                  }}
                />
                <Select2
                  searchable
                  value={timeZone}
                  onChange={e => uiState.setTimeZone(e.target.value)}
                  label='recruiting.schedule_interview.Time Zone'
                >
                  {timeZoneOptions.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </Select2>
              </div>
            </div>
            <div className='col-span-4'>
              <div className='h3 medium'>
                {selectedDate && calendarDate(selectedDate, {includeDayOfWeek: true})}
              </div>
              <div className='mt2 flex flex-wrap gap-1'>
                {uiState.slotsForDate(selectedDate).map(slot => (
                  <div
                    key={slot.startTime}
                    className={`cursor-pointer rounded border p-4 transition-colors ${selectedSlot?.startTime === slot.startTime ? 'bg-dodger text-white' : ''}`}
                    onClick={() => uiState.setSelectedSlot(slot)}
                  >
                    {slot.startTime}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Panel>
        <div className='my2 right-align'>
          <Button disabled={!selectedSlot} trait='primary' onClick={() => uiState.submit()}>
            <FormattedMessage id='recruiting.schedule_interview.Schedule Interview'/>
          </Button>
        </div>
      </Layout>
    </div>
  );
});

export default withState(ScheduleInterviewContainer, ScheduleInterviewState);
